import React from 'react';
import {Container, Row, Col, Table, Form} from 'react-bootstrap';
import '../layout/main.scss';
import './request.scss';
import spsog from '../../images/sp-sog.png';


function Request() {
    return (
        <div className="App">
            <div className="asset">
                <Container>
                    <div className="cardAssetinfo">
                        <h4>Request certificate</h4>
                        <Row>
                            <Col className="col-sm-12 col-md-6">
                                <div className="cards">
                                    <div className="collections_filters">
                                        <span>Asset chain</span>
                                        <Form.Select aria-label="SelectChain">
                                            <option>Choose</option>
                                            <option value="1">Bitcoin/Counterparty</option>
                                            <option value="2">Ethereum</option>
                                            <option value="3">Klaytn</option>
                                            <option value="4">Kusama</option>
                                        </Form.Select>
                                    </div>
                                    <div className="collections_filters">
                                        <span>Contract ID</span>
                                        <input type="input" id="contract" name="contract" placeholder="0xj5V5vthTc6...kejf5Cc5Zd"/>
                                    </div>
                                    <div className="collections_filters">
                                        <span>Token ID</span>
                                        <input type="input" id="tokenid" name="tokenid" placeholder="28912"/>
                                    </div>
                                </div>
                                <div className="certif_img"><img src={spsog}/></div>
                            </Col>
                            <Col className="col-sm-12 col-md-6">
                                <div className="cards">
                                    <div className="collections_filters">
                                        <span>KIWAKU stake</span>
                                        <input type="input" id="tokenid" name="tokenid" placeholder="10"/>
                                    </div>
                                    <div className="collections_filters2">
                                        <span>Certificate content</span>
                                        <textarea rows={6}>
                                            I certify that I own the IP of this picture for this NFT and that only one edition will ever be produced
                                        </textarea>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <h4>Attachments</h4>
                            <Col className="col-sm-12">
                                <div className="cards">
                                    <Table hover>
                                        <tbody>
                                        <tr>
                                            <th>Title</th>
                                            <th>Type</th>
                                            <th>Remove</th>
                                        </tr>
                                        <tr>
                                            <td>Photo of original art</td>
                                            <td>Picture</td>
                                            <td><input type="checkbox" /></td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="col-sm-12 request-btn">
                                <a href="/ViewCertificate"><button>Request certificate</button></a>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default Request;
